import { useTaxApi } from "../api/TaxApiClient";
import { TaxFrontendService } from "../services/TaxFrontendService";

export const useTaxService = (): TaxFrontendService =>
  new TaxFrontendService(useTaxApi());
